<script lang="ts">
  import { invalidate } from '$app/navigation';
  import { page } from '$app/stores';
  import { openPreferencesTab } from '$components/preferences/PreferencesTabs.svelte';
  import type { LayoutConfig } from '$types/races';
  import { isSubscribed } from '$utils/auth';
  import { createMenu } from 'svelte-headlessui';
  import Transition from 'svelte-transition';
  import TablerLayout from '~icons/tabler/layout';

  export let sortRunners: (() => void) | undefined;

  $: ({ layoutConfigStore } = $page.data);
  $: activeLayoutConfigName = layoutConfigStore?.activeLayoutConfigName;

  const menu = createMenu({ label: 'Layouts' });

  async function onSelect(e: Event) {
    if (!layoutConfigStore || !activeLayoutConfigName) {
      console.error('no layout config store');
      return;
    }
    const selectedLayout = layoutConfigStore.getOne(
      (e as CustomEvent).detail.selected
    ) as LayoutConfig;

    if (selectedLayout && $activeLayoutConfigName !== selectedLayout.name) {
      menu.close();

      activeLayoutConfigName.set(selectedLayout.name);
      //   invalidate the race so we fetch the right data
      invalidate('betwatch:race').then(() => {
        //   sort the runners
        if (sortRunners) {
          sortRunners();
        }
      });
    }
  }

  function handleCustomiseClick() {
    openPreferencesTab('Customise Layouts');
    menu.close();
  }
</script>

<div class="relative inline-block text-left">
  <button
    use:menu.button
    on:select={onSelect}
    class="flex flex-row rounded-br-lg bg-gradient-to-br from-orange-100 to-orange-200 px-2 py-3 text-sm font-semibold leading-4 text-gray-900 shadow-sm hover:cursor-pointer hover:from-orange-200 hover:to-orange-200 hover:text-black"
  >
    <span class="mr-1 text-gray-500">Layout:</span>
    <span>{$activeLayoutConfigName}</span>
    <svg
      class="ml-2 h-4 w-4"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 9l-7 7-7-7"
      />
    </svg>
  </button>

  <Transition show={$menu.expanded}>
    <div
      use:menu.items
      class="absolute left-1 top-11 z-30 mb-20 max-h-96 w-44 divide-y divide-gray-100 overflow-y-auto rounded-md bg-white text-sm shadow-md"
    >
      <div class="text-gray-900">
        {#each $layoutConfigStore ?? [] as layout, i}
          <button
            use:menu.item
            class="block w-full cursor-pointer {i === 0
              ? 'rounded-t-md'
              : 'border-t'} px-4 py-3 text-left
							 {layout.name === 'Default Win' || layout.name === 'Default Place'
              ? 'bg-gray-100 font-semibold hover:bg-gray-200'
              : 'hover:bg-gray-100'}"
          >
            {layout.name}
          </button>
        {/each}
      </div>
      {#if $isSubscribed}
        <button
          on:click={handleCustomiseClick}
          class="hidden w-full cursor-pointer flex-row items-center rounded-b-md border-t-2 bg-orange-50 px-2 py-2 text-left hover:bg-orange-100 md:flex"
        >
          <TablerLayout class="mr-2 h-5 w-5 text-gray-800/80" />
          Customise Layouts
        </button>
      {/if}
    </div>
  </Transition>
</div>
